import React from "react"

import { ShieldOff } from "lucide-react"
import { Navigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthContext"

/** Sign-in proves a HIVED Workspace account; access is the collections_access role claim. */
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isAuthorised, loading, signOut } = useAuth()

  if (loading) {
    return (
      <div className="flex h-[var(--app-vh)] items-center justify-center text-sm text-gray-500">
        Loading…
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  if (!isAuthorised) {
    return (
      <div className="flex min-h-[var(--app-vh)] items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
          <ShieldOff className="mx-auto mb-4 text-gray-400" size={28} aria-hidden="true" />
          <h1 className="text-lg font-semibold text-gray-900">No access to collections</h1>
          <p className="mt-2 text-sm text-gray-600">
            You&rsquo;re signed in as <span className="font-medium">{user.email}</span>, but that
            account isn&rsquo;t on the collections access list. Ask a collections admin to add you.
          </p>
          <Button variant="outline" className="mt-6" onClick={() => void signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
